module.exports = __webpack_public_path__ + "img/planta_04.b09b246f.png";